import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Layout from './components/Layout';
import Marketing from './pages/Marketing';
import Calendar from './pages/Calendar';
import Transformations from './pages/Transformations';
import Relances from './pages/Relances';
import WhatsApp from './pages/WhatsApp';
import Absences from './pages/Absences';
import Settings from './pages/Settings';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Chargement...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const App = () => {
  const { user } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={user ? <Navigate to="/" replace /> : <Login />} 
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Marketing />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/transformations" element={<Transformations />} />
                <Route path="/relances" element={<Relances />} />
                <Route path="/whatsapp" element={<WhatsApp />} />
                <Route path="/absences" element={<Absences />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default App;
